import { z } from 'zod'

export const edyOrganizationSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['name', 'regno', 'planend', 'usercount', 'activeinterns']).catch('name'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type EdyOrganizationSearch = z.infer<typeof edyOrganizationSearchSchema>

export const defaultEdyOrganizationSearch: EdyOrganizationSearch = {
  page: 1,
  pageSize: 10,
  sortBy: 'name',
  direction: 'asc',
}
